/**
 * accounts.url（例: https://iias-kasugai.plum-gate.com/api/join/freetime）から
 * 現行 Web予約 URL を組み立てる。
 */
export function getPlumLinkReserveUrl(apiUrl) {
  if (!apiUrl) return null
  const match = String(apiUrl).match(/^https?:\/\/([^.]+)\.plum-gate\.com/i)
  if (!match) return null
  return `https://${match[1]}.plum-link.com/reserve/#/home`
}
